
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/armed-forces-support",
      function () {
        return require("private-next-pages/armed-forces-support/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/armed-forces-support"])
      });
    }
  